import { Component, OnInit } from '@angular/core';
import { StepType, RegistrationStepService, ErrorStateService, AlertModel } from '@fgb/core';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Component({
  selector: 'fgb-registration-opt-out-alerts',
  templateUrl: './registration-opt-out-alerts.component.html',
  styleUrls: ['./registration-opt-out-alerts.component.scss'],
})
export class RegistrationOptOutAlertsComponent implements OnInit {
  readonly stepType: StepType = StepType.OptOutAlerts;
  optOutAlerts$: Observable<AlertModel[]>;
  optOutAlerts: AlertModel[] = [];

  constructor(private registrationStepService: RegistrationStepService, public errorService: ErrorStateService) {}

  ngOnInit() {
    this.optOutAlerts$ = this.registrationStepService.fetchRegistrationStepForCurrentWizard(this.stepType).pipe(
      map((step) => (step ? step.Data : undefined)),
      tap((alerts) => {
        alerts.forEach((alert) => {
          if (!alert.IsHidden) {
            this.optOutAlerts.push(alert);
          }
        });
      })
    );
  }

  submitStep() {
    const stepData = this.optOutAlerts;
    if (stepData) {
      this.registrationStepService.submitRegistrationStepData(this.stepType, stepData).toPromise();
    }
  }
}
